import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import { useTheme } from '@mui/material/styles';

import { COLORS } from '../../utils/ColorsTheme';

const Footer = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const dateYear = new Date().getFullYear();
  const iconColor = isDarkMode ? COLORS.darkModeColor : COLORS.lightModeColor;
  const scrollToTopHandler = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <footer
      className='footer text-center text-lg-start text-muted mt-auto'
      style={{
        backgroundColor: isDarkMode ? COLORS.secondaryDarkMode : COLORS.headerLightMode,
      }}
    >
      <section className='d-flex justify-content-center justify-content-lg-between p-4'>
        <div className='me-5 d-none d-lg-block'>
          <span className={`fw-bold ${isDarkMode ? 'text-white' : 'text-dark'}`}>
            Get connected with us on social networks:
          </span>
        </div>
        <div>
          <a
            target='_blank'
            rel='noreferrer'
            href='https://www.facebook.com/akshay.bandivadekar.1'
            className='me-4 link-secondary'
          >
            <FacebookIcon htmlColor={iconColor} />
          </a>
          <a
            target='_blank'
            rel='noreferrer'
            href='https://twitter.com/Er_AkshayB'
            className='me-4 link-secondary'
          >
            <TwitterIcon htmlColor={iconColor} />
          </a>
          <a
            target='_blank'
            rel='noreferrer'
            href='https://github.com/akshaybandivadekar'
            className='me-4 link-secondary'
          >
            <GitHubIcon htmlColor={iconColor} />
          </a>
          <a
            target='_blank'
            rel='noreferrer'
            href='https://www.linkedin.com/in/akshay-bandivadekar'
            className='me-4 link-secondary'
          >
            <LinkedInIcon htmlColor={iconColor} />
          </a>
        </div>
      </section>
      <div
        className='d-flex justify-content-center justify-content-lg-between p-4'
        style={{
          backgroundColor:
            theme.palette.mode === 'dark' ? COLORS.defaultDarkMode : COLORS.defaultLightMode,
        }}
      >
        <div
          className={`text-center ${isDarkMode ? 'text-white' : 'text-dark'}`}
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.025)' }}
        >
          © {dateYear} Copyright:
          <a
            className={`fw-bold ${isDarkMode ? 'text-white' : 'text-dark'}`}
            target='_blank'
            rel='noreferrer'
            href='https://blog.akshaybandivadekar.vercel.app/'
          >
            Akshay Bandivadekar&apos;s Blog
          </a>
        </div>
        <div>
          <ArrowCircleUpIcon
            className='me-4 cursor-pointer'
            htmlColor={iconColor}
            onClick={scrollToTopHandler}
            data-testid='scroll-to-top'
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
